/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';

export const EMAIL_MAX_RETRY_IN_MINUTES = 60 * 6; // 6 hours
export const EMAIL_MAX_ATTEMPTS = 50;

export default declareEntity({
    entity: "flowIncomingEmails",
    graphQL: "FlowIncomingEmail",
    name: "Flow Incoming Email",
    dynamoPrefix: 'org',
    storageType: 'central',
    defaultOrder: [['createdAt', 'desc']],
    parentRelation: 'flowIncomingEmails',
    userEditable: false,
    optimizeReading: true,
    defaultTitle: (data) => {
        return data['createdAt'];
    },
    fields: (types) => { return {
        id: {
            name: "Flow Incoming Mail ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
            defaultValue: (flow) => {
                if (flow) {
                    return flow['id'];
                }
            },
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
        },
        flowStepDef: {
            name: "Flow Step Definition",
            type: "relation",
            to: () => types['flowStepDefs'],
            relativeTo: ['flowDef'],
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (flow) => {
                if (flow) {
                    return flow['instance_id'];
                }
            },
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (flow) => {
                return flow['organisation_id'];
            },
            required: true,
            hiddenCreate: true,
        },
        emailSubject: {
            name: "Subject",
            type: "string",
        },
        emailSender: {
            name: "Sender",
            type: "string",
        },
        emailRecepient: {
            name: "Recipient",
            type: "string",
        },
        originalRequest: {
            name: "Original request content",
            type: "binary",
            offload: true,
        },
        processed: {
            name: "Processed",
            type: "boolean",
            filterable: true,
            defaultValue: false,
        },
        failed: {
            name: "Failed",
            type: "boolean",
            filterable: true,
            defaultValue: false,
        },
        nextRetry: {
            name: "Next Retry at",
            type: "datetime",
        },
        attempt: {
            name: "Attempt",
            type: "int",
            defaultValue: 0,
        },
        firstProcessedAt: {
            name: "First Processed at",
            type: "datetime",
        },
        firstFlowInvocation: {
            name: "First Flow Invocation",
            type: "relation",
            to: () => types['flowInvocations'],
            userEditable: false,
        },
        lastProcessedAt: {
            name: "Last Processed at",
            type: "datetime",
        },
        lastFlowInvocation: {
            name: "Last Flow Invocation",
            type: "relation",
            to: () => types['flowInvocations'],
            userEditable: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
            filterable: true,
        }
    }; },
    relations: (types) => { return {
    }; }
});
